import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page38() {
  useEffect(() => {
    document.title = "Маяк — Страница 37"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page36" />
        <ForwardLink href="/page38" />
      </div>

      <p style={{ textAlign: "right" }}>37.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК (ПРОДОЛЖЕНИЕ)<br/>
        (громче)<br/>
        <i>Истина...</i>
      </p>
      <p>Глаза МОЛОДОГО расширяются.</p>
      <br/>
      <p>ВНУТРИ. ЖИЛЫЕ ПОМЕЩЕНИЯ. КАМБУЗ – ДЕНЬ</p>
      <p>МОЛОДОЙ качает воду в чашку в раковине.</p>
      <p>
        Пьет. Качает снова. Пьет. Собирается качать снова, но
        что-то останавливает его...
      </p>
      <p>На дне чашки темная пленка.</p>
      <p>Он протирает ее пальцем и смотрит: <i>странно.</i></p>
      <p>Затем ТУК, ТУК, ТУК по окну. Кажется, он этого не слышит.</p>
      <p>
        МОЛОДОЙ снова качает воду... издается ржавый, булькающий<br/>
        звук... вода становится все более и более загрязненной, почти черной.
      </p>
      <p>В этот момент он слышит ЖАЛОБНЫЙ КРИК ЧАЙКИ снаружи.</p>
      <br/>
      <p>СНАРУЖИ. КАМЕННЫЙ ОСТРОВ. ЦИСТЕРНА – ДЕНЬ</p>
      <p>
        МОЛОДОЙ выходит через заднюю дверь. Смотрит<br/>
        на цистерну.
      </p>
      <p>КРИК продолжается.</p>
      <p>Он медленно идет к цистерне.</p>
      <p>ЛЮК ЦИСТЕРНЫ ОТКРЫТ.</p>
      <p>КРИК становится громче, когда он приближается.</p>
      <p>Он смотрит внутрь:</p>
      <p>
        МЕРТВЫЕ ЧАЙКИ плавают в окровавленной цистерне. ОДНА ЧАЙКА пытается<br/>
        выбраться -- жалко, отчаянно -- крича. Ее крыло<br/>
        сломано.
      </p>
      <p>
        В ЭТОТ МОМЕНТ НАВЕРХУ РАЗДАЕТСЯ ГРОМКИЙ ТРЕПЕТ КРЫЛЬЕВ...<br/>
        и звук приземляющейся чайки.
      </p>
      <p>МОЛОДОЙ СМОТРИТ ВВЕРХ...</p>
      <p>
        ОДНОГЛАЗАЯ ЧАЙКА СТОИТ НА КРЫШКЕ ЦИСТЕРНЫ... ОНА ПОДНИМАЕТ<br/>
        КРЫЛЬЯ И ВСТАЕТ ПРЯМО, АГРЕССИВНО ДЕРГАЯСЬ...<br/>
        ОНА РАСКРЫВАЕТ СВОЙ КЛЮВ ШИРЕ ЧЕМ КОГДА-ЛИБО И ИЗДАЕТ ГРОМКИЙ<br/>
        УЖАСАЮЩИЙ ДЛИННЫЙ КРИК ПРЯМО НА МОЛОДОГО!
      </p>
      <p style={{ textAlign: "right" }}>37.</p>
      
      <Navigation />
      
      <div className="NavigationLink-wrapper">
        <BackLink href="/page36" />
        <ForwardLink href="/page38" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1710021397/the-lighthouse-script/br1norxbytkmlxtkjiob.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page38;
